import React from "react";
import styled from "styled-components";
import pick from "lodash/pick";

import * as T from "../../components/Typography";
import * as u from "../../utils";
import * as gtag from "../../utils/gtag";
import * as UserContext from "../../components/UserContext";
import firebase from "../../firebase.client";
import EventCollection from "../../components/EventCollection";
import EventCard from "../../components/EventCard";
import EventVideoCard from "../../components/EventVideoCard";
import RxSubNavEvents from "../../components/ui/navigation/RxSubNavEvents";

export default function Events(props) {
  const userInfo = React.useContext(UserContext.Context);
  const [myEvents, setMyEvents] = React.useState();
  const isLoggedIn = !!userInfo.id;
  const showLock = isLoggedIn && !userInfo.isPaid;

  React.useEffect(() => {
    fetchMyEvents();
  }, [userInfo]);

  return (
    <>
      <RxSubNavEvents />
      <S.Container>{getContent()}</S.Container>
    </>
  );

  async function fetchMyEvents() {
    if (!userInfo.id) return;
    const data = (
      await firebase.firestore().collection("users").doc(userInfo.id).get()
    ).data();
    if (data?.events?.length) return setMyEvents(data.events);

    setMyEvents(false);
  }

  function getContent() {
    const loggedOut = !userInfo.id;

    if (loggedOut) {
      return (
        <T.CXL>
          Sign up or log in and you will see your events listed here.
        </T.CXL>
      );
    }

    if (myEvents === false) {
      return (
        <T.CXL>
          You do not have any upcoming or past events. RSVP to an event and it
          will appear here.
        </T.CXL>
      );
    }

    return (
      <EventCollection initialListSize={8}>
        {getMyEvents(props.events).map(getBothEvent)}
      </EventCollection>
    );
  }

  function getMyEvents(events) {
    if (!myEvents) return [];
    let copy = [...events];
    return copy.filter(byMyEvent);

    function byMyEvent(event) {
      return myEvents.includes(event.id);
    }
  }

  function getBothEvent(props, index) {
    if (props.recordedEventVideoUrl) {
      return (
        <EventVideoCard
          key={index}
          index={index}
          {...props}
          onClick={() => onClick(props)}
        />
      );
    } else {
      return (
        <EventCard
          key={index}
          index={index}
          showLock={showLock}
          {...props}
          onClick={() => onClick(props)}
        />
      );
    }

    function onClick(event) {
      gtag.event({
        name: gtag.GA_EVENT.EVENT_ENGAGEMENT,
        category: "Events",
        label: "From My Events",
        value: event.title,
      });
    }
  }
}

export async function getStaticProps() {
  const firebase = require("../../firebase.admin");
  const eventsRef = firebase
    .firestore()
    .collection("events")
    .where("status", "!=", "DRAFT")
    .orderBy("status", "desc")
    .orderBy("endTime", "desc")
    .limit(400);
  const events = (await eventsRef.get()).docs.map((doc) =>
    pick(doc.data(), [
      "cardImage",
      "endTime",
      "exclusiveGroups",
      "id",
      "isFree",
      "location",
      "memberAccess",
      "recordedEventVideoUrl",
      "startTime",
      "tags",
      "title",
    ])
  );

  return { props: { events }, revalidate: 3600 };
}

const S = {};

S.Container = styled.div`
  max-width: 1440px;
  margin: auto;
  padding: 20px 16px;

  @media ${u.device.tablet} {
    padding: 20px;
  }

  @media ${u.device.desktop} {
    padding: 40px;
  }
`;
